import { setDialog } from 'getaway-data-layer';
import { store } from '../redux/config';
import { DialogOption } from '../ui/components/Dialog/Dialog';

export const showAlert = (
  title: string,
  message: string,
  yesActionText: any = null,
  yesAction: () => void = () => {},
  noActionText: any = null,
  noAction: () => void = () => {},
  isDestructive: boolean = false
) => {
  const dialog = {
    title,
    message,
    yesActionText,
    yesAction,
    noActionText,
    noAction,
    isDestructive,
  };
  store.dispatch(setDialog(dialog));
};

export const showAlertWithOptions = (
  title: string,
  message: string,
  options: DialogOption[] = [],
  isDestructive: boolean = false
) => {
  const dialog = {
    title,
    message,
    options,
    isDestructive,
  };
  store.dispatch(setDialog(dialog));
};

export const showPaypalAlert = (
  title: string,
  message: string,
  actionComponent: () => any = () => {},
  noActionText: any = null,
  noAction: () => void = () => {},
  isDestructive: boolean = false
) => {
  const dialog = {
    title,
    message,
    actionComponent,
    noActionText,
    noAction,
    isDestructive,
  };
  store.dispatch(setDialog(dialog));
};
